/* eslint-disable no-mixed-operators */
import Cookies from "js-cookie";
// let imageList = [];
// import icons from "../assets/icons.json";

// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = (obj) => Object.keys(obj).length === 0;

// ** Returns K format from a number
export const kFormatter = (num) => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num);

// ** Converts HTML to string
export const htmlToString = (html) => html.replace(/<\/?[^>]+(>|$)/g, "");

// ** Checks if the passed date is today
const isToday = (date) => {
  const today = new Date();
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  );
};

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (
  value,
  formatting = { month: "short", day: "numeric", year: "numeric" }
) => {
  if (!value) return value;
  return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};

// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value);
  let formatting = { month: "short", day: "numeric" };

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: "numeric", minute: "numeric" };
  }

  return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 **
 ** IMPORTANT: We check both userData AND accessToken to ensure the user has completed
 ** the full authentication flow. This prevents issues where:
 ** 1. User has 2FA enabled and is in the middle of verification
 ** 2. Old userData exists but token has expired
 ** 3. User data exists but no valid JWT token is present
 */
export const isUserLoggedIn = () => {
  const userData = localStorage.getItem("userData");
  const accessToken = localStorage.getItem("accessToken");

  // User is only considered logged in if BOTH userData and accessToken exist
  // This ensures they've completed the full auth flow including 2FA if enabled
  return userData && accessToken;
};

export const getUserData = () => JSON.parse(localStorage.getItem("userData"));

/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = (userRole) => {
  if (userRole === "admin") return "/";
  if (userRole === "client") return "/access-control";
  return "/login";
};

// ** React Select Theme Colors
export const selectThemeColors = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: "#7367f01a", // for option hover bg-color
    primary: "#7367f0", // for selected option bg-color
    neutral10: "#7367f0", // for tags bg-color
    neutral20: "#ededed", // for input border-color
    neutral30: "#ededed", // for input hover border-color
  },
});

export const currencyFormat = (number) =>
  isNaN(number) ? "0" : new Intl.NumberFormat().format(number);

export const p2e = (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
export const a2e = (s) => s.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d));

export const getBankName = (s) => {
  if (!s) return "";
  const first6 = s.split(" ").join("").slice(0, 6);
  switch (first6) {
    case "603799":
      return "meli";
    case "589210":
      return "sepah";
    case "627961":
      return "sanatmadan";
    case "603770":
      return "keshavarsi";
    case "628023":
      return "maskan";
    case "627760":
      return "postbank";
    case "502908":
      return "tosehe";
    case "627412":
      return "eghtesad";
    case "622106":
      return "parsian";
    case "502229":
      return "pasargad";
    case "627488":
      return "karafarin";
    case "621986":
      return "saman";
    case "639346":
      return "sina";
    case "639607":
      return "sarmaye";
    case "502806":
      return "shahr";
    case "502938":
      return "day";
    case "603769":
      return "saderat";
    case "610433":
      return "mellat";
    case "627353":
      return "tejarat";
    case "585983":
      return "tejarat";
    case "589463":
      return "refah";
    case "627381":
      return "ansar";
    case "639370":
      return "mehreqtesad";
    case "639599":
      return "ghavamin";
    case "504172":
      return "resalat";
    case "505416":
      return "gardeshgari";
    case "606256":
      return "melal";
    default:
      return "";
    // break
  }
};

export const findCryptoIcon = (symbol) => {
  const project_url = process.env.REACT_APP_CRYPTO_URL;
  return `${project_url}/icons/currency/${symbol?.toUpperCase()}.png`;

  // let cryptoIcon = imageList.filter(
  //   (icon) => icon.symbol.toLowerCase() === symbol?.toLowerCase()
  // );
  // if (cryptoIcon.length !== 0) {
  //   return cryptoIcon[0].img_url;
  // }
  // cryptoIcon = icons.filter(
  //   (icon) => icon.symbol.toLowerCase() === symbol?.toLowerCase()
  // );
  // if (cryptoIcon.length === 0) {
  //   return "";
  // } else {
  //   imageList = [
  //     ...imageList.filter((image) => image.symbol !== cryptoIcon[0].symbol),
  //     cryptoIcon[0],
  //   ];
  //   return cryptoIcon[0].img_url;
  // }
};

export const getPersianBankName = (s) => {
  const first6 = s.split(" ").join("").slice(0, 6);
  switch (first6) {
    case "603799":
      return "ملی";
    case "589210":
      return "سپه";
    case "627961":
      return "صنعت معدن";
    case "603770":
      return "کشاورزی";
    case "628023":
      return "مسکن";
    case "627760":
      return "پست بانک";
    case "502908":
      return "توسعه تعاون";
    case "627412":
      return "اقتصاد";
    case "622106":
      return "پارسیان";
    case "502229":
      return "پاسارگاد";
    case "627488":
      return "کارآفرین";
    case "621986":
      return "سامان";
    case "639346":
      return "سینا";
    case "639607":
      return "سرمایه";
    case "502806":
      return "شهر";
    case "502938":
      return "دی";
    case "603769":
      return "صادرات";
    case "610433":
      return "ملت";
    case "627353":
      return "تجارت";
    case "589463":
      return "رفاه";
    case "627381":
      return "انصار";
    case "639370":
      return "مهراقتصاد";
    case "639599":
      return "قوامین";
    case "504172":
      return "رسات";
    case "585983":
      return "تجارت";
    default:
      return "بدون نام";
    // break
  }
};

export const fixedAmount = (amount, count) =>
  amount && +amount.toFixed(count).replace(/[.,]00000000$/, "");

import i18next from "i18next";

export const timeSince = (isoDate) => {
  if (!isoDate) return "";

  const currentDate = new Date();

  // Parse the date string properly to handle format "YYYY-MM-DD HH:MM:SS"
  // Server sends UTC time, so we need to parse it as UTC
  let targetDate;
  if (isoDate.includes("T")) {
    // ISO format with T - already handles UTC properly
    targetDate = new Date(isoDate);
  } else {
    // Format: "YYYY-MM-DD HH:MM:SS" - parse as UTC time
    const parts = isoDate.split(" ");
    const dateParts = parts[0].split("-");
    const timeParts = parts[1] ? parts[1].split(":") : ["0", "0", "0"];

    // Use Date.UTC to create a UTC timestamp, then convert to Date object
    targetDate = new Date(
      Date.UTC(
        parseInt(dateParts[0]), // year
        parseInt(dateParts[1]) - 1, // month (0-based)
        parseInt(dateParts[2]), // day
        parseInt(timeParts[0]), // hours
        parseInt(timeParts[1]), // minutes
        parseInt(timeParts[2] || 0) // seconds
      )
    );
  }

  // Check if date is valid
  if (isNaN(targetDate.getTime())) {
    console.warn('Invalid date format in timeSince:', isoDate);
    return "";
  }

  // Calculate time difference in seconds
  const secondsElapsed = Math.floor(
    (currentDate.getTime() - targetDate.getTime()) / 1000
  );

  const intervals = [
    { label: { en: "year", fa: "سال" }, seconds: 31536000 },
    { label: { en: "month", fa: "ماه" }, seconds: 2592000 },
    { label: { en: "day", fa: "روز" }, seconds: 86400 },
    { label: { en: "hour", fa: "ساعت" }, seconds: 3600 },
    { label: { en: "minute", fa: "دقیقه" }, seconds: 60 },
  ];

  const language = i18next.language;

  for (const interval of intervals) {
    const intervalValue = secondsElapsed / interval.seconds;
    if (intervalValue >= 1) {
      const roundedValue = Math.floor(intervalValue);
      const labelKey = language === "en" ? "en" : "fa";
      return `${roundedValue} ${interval.label[labelKey]} ${
        language === "en" ? "ago" : "پیش"
      }`;
    }
  }

  return language === "en" ? "A few moments ago" : "چند لحظه پیش";
};

export const nFormatter = (num) => {
  if (num >= 1000000000) {
    return `${(num / 1000000000).toFixed(2).replace(/\.0$/, "")}G`;
  }
  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(2).replace(/\.0$/, "")}M`;
  }
  if (num >= 1000) {
    return `${(num / 1000).toFixed(2).replace(/\.0$/, "")}K`;
  }
  return num;
};

export const setCookieWithExpiry = (name, value, minutes) => {
  const expiryDate = new Date();
  expiryDate.setTime(expiryDate.getTime() + minutes * 60 * 1000); // Convert minutes to milliseconds
  Cookies.set(name, value, { expires: expiryDate });
};

export function formatNumberWithCommas(number) {
  // Ensure the input is a number and convert it to a string
  const numberString = (
    typeof number === "number" ? number : parseFloat(number)
  ).toString();

  // Split the string into parts before and after the decimal point (if any)
  const [integerPart, decimalPart] = numberString.split(".");

  // Add commas to the integer part for thousands separation
  const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Combine the formatted integer part and the decimal part (if any)
  const formattedNumber = decimalPart
    ? `${formattedIntegerPart}.${decimalPart}`
    : formattedIntegerPart;

  return formattedNumber;
}

function convertDate(inputDate) {
  if (!inputDate) return;

  // Check if the input date is in type 2 format
  if (inputDate.includes("T")) {
    // Convert type 2 to type 1
    const dateObj = new Date(inputDate);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    const hours = String(dateObj.getHours()).padStart(2, "0");
    const minutes = String(dateObj.getMinutes()).padStart(2, "0");
    const seconds = String(dateObj.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  } else {
    // If it's already type 1, return it as is
    return inputDate;
  }
}
export function parseAndFormatDate(dateType) {
  if (!dateType) return;

  const dateStr = convertDate(dateType);
  // Split the date and time components
  const parts = dateStr.split(" ");
  const dateParts = parts[0].split("-");
  const timeParts = parts[1].split(":");

  // Create a new date object using the specified parts.
  // Note that months are 0-based in JavaScript: 0 for January, 1 for February, etc.
  // Server sends UTC time, so we parse it as UTC using Date.UTC
  const date = new Date(
    Date.UTC(
      dateParts[0],
      dateParts[1] - 1,
      dateParts[2],
      timeParts[0],
      timeParts[1],
      timeParts[2]
    )
  );

  // Return the date formatted in the user's local timezone
  // The date object is already in UTC, so it will automatically convert to local timezone
  return date.toLocaleDateString(i18next.language === "ir" ? "fa-IR" : "en-US", {
    hour12: false, // Use 24-hour time if preferred
  });
}

// Function to check if order is market buy (should show TBD in quantity)
export function isMarketBuyOrder(order) {
  if (!order) return false;
  return +order.status === 0 && +order.type === 1 && +order.role === 1;
}

// Function to check if order is market sell (should show TBD in total amount)
export function isMarketSellOrder(order) {
  if (!order) return false;
  return +order.status === 0 && +order.type === 1 && +order.role === 2;
}

// Function to check if order should show TBD in quantity column
export function shouldShowTBDInQuantity(order) {
  return isMarketBuyOrder(order);
}

// Function to check if order should show TBD in total amount column
export function shouldShowTBDInTotalAmount(order) {
  return isMarketSellOrder(order);
}

// Function to format order quantity with TBD handling for market buy orders
export function formatOrderQuantity(order) {
  if (!order) return "";

  // For market buy orders (status=0, type=1, role=1), show "TBD"
  if (shouldShowTBDInQuantity(order)) {
    return "TBD";
  }

  return order.amount;
}

// Function to format total amount with TBD handling for market sell orders
export function formatTotalAmount(order) {
  if (!order) return "";

  // For market sell orders (status=0, type=1, role=2), show "TBD"
  if (shouldShowTBDInTotalAmount(order)) {
    return "TBD";
  }

  return order.total_price;
}

// Function to get proper order type translation
export function getOrderTypeTranslation(type, t) {
  switch (+type) {
    case 1:
      return t("Market"); // Changed from "Market Type" to "Market"
    case 2:
      return t("Limit");
    case 3:
      return t("OTC"); // Changed from "Fast" to "OTC" for quick orders
    default:
      return t("Unknown");
  }
}

export function parseAndFormatDateTime(dateType) {
  if (!dateType) return;

  const dateStr = convertDate(dateType);
  // Split the date and time components
  const parts = dateStr.split(" ");
  const dateParts = parts[0].split("-");
  const timeParts = parts[1].split(":");

  // Create a new date object using the specified parts.
  // Note that months are 0-based in JavaScript: 0 for January, 1 for February, etc.
  // Server sends UTC time, so we parse it as UTC using Date.UTC
  const date = new Date(
    Date.UTC(
      dateParts[0],
      dateParts[1] - 1,
      dateParts[2],
      timeParts[0],
      timeParts[1],
      timeParts[2]
    )
  );

  // Return the date and time formatted in the user's local timezone
  // The date object is already in UTC, so it will automatically convert to local timezone
  return date.toLocaleString(i18next.language === "ir" ? "fa-IR" : "en-US", {
    hour12: false, // Use 24-hour time
  });
}

//  function truncateDecimal(originalNumber, decimalPlaces) {
//   // eslint-disable-next-line no-mixed-operators
//   return Math.floor(originalNumber * 10 ** decimalPlaces) / 10 ** decimalPlaces;
// }

export function truncateDecimal(number, decimalPlaces) {
  if (number === null || isNaN(number)) {
    return 0;
  }

  const factor = 10 ** decimalPlaces;
  return Math.trunc(number * factor) / factor;
}
export function plainNumberFun(inputValue) {
  if (!inputValue) return 0;

  if (typeof inputValue === "number" || inputValue === null) {
    return inputValue;
  }
  // Remove commas from the input
  const withoutCommas = inputValue?.replace(/,/g, "");

  // Use regular expression to check if the modified input is a number with decimal part
  const decimalRegex = /^[-+]?\d*\.?\d+$/;

  // Test the modified input against the regular expression
  if (decimalRegex.test(withoutCommas)) {
    return +withoutCommas;
  } else {
    // Handle invalid input (non-numeric or malformed numeric input)
    // console.error("Invalid input:", inputValue)
    return null; // or some default value, depending on your use case
  }
}

import io from "socket.io-client";

export const createSocket = () => {
  const accessToken = JSON.parse(localStorage.getItem("userData"))?.accessToken;
  const socket = io("https://notif2.bitazar.com", {
    transports: ["polling", "websocket"], // Standard: polling → websocket upgrade
    query: {
      token: `${accessToken}`,
    },
    reconnectionDelay: 2000,
    pingInterval: 10000,
    pingTimeout: 30000,
    // Enhanced connection options
    reconnection: true,
    reconnectionAttempts: 5,
    timeout: 20000,
  });

  return socket;
};

export function convertPersianNumbersToEnglish(input) {
  if (typeof input !== "string") return input;

  try {
    const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];

    let output = input;

    persianNumbers.forEach((regex, index) => {
      output = output.replace(regex, index.toString());
    });

    return output;
  } catch (error) {
    return 0;
  }
}

/**
 * Truncates a long string (like crypto addresses or transaction hashes) to show first and last characters
 * @param {string} str - The string to truncate
 * @param {number} startChars - Number of characters to show at the start (default: 6)
 * @param {number} endChars - Number of characters to show at the end (default: 4)
 * @returns {string} - Truncated string with ellipsis in the middle
 */
export function truncateAddress(str, startChars = 6, endChars = 4) {
  if (!str) return "-";
  if (str.length <= startChars + endChars) return str;
  return `${str.substring(0, startChars)}...${str.substring(str.length - endChars)}`;
}
